import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { deleteMAGAF020, getMAGAF020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';

import { decodeHTML } from 'entities';
import moment from 'moment';
import CheckGroup from '../../../shared/components/CheckGroup';
import { MENU_CENTER, MESSAGE } from '../../../shared/constants/app';

const MAGAF030 = () => {
    const { id } = useParams();
    const [data, setData] = useState({});

    useEffect(() => {
        if (id) {
            getMAGAF020(id)
                .then(({ data }) => {
                    setData({
                        ...data,
                        contents: decodeHTML(data.contents || ''),
                    });
                })
                .catch((error) => console.log(error));
        }
    }, [id]);
    const formatDate = (date) => (date ? moment(date).locale('ko').format('YYYY.MM.DD') : '');
    const getGubun = (gubun) => {
        switch (gubun) {
            case '01':
                return '공지';
            case '02':
                return '뉴스';
            default:
                return '';
        }
    };
    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAGAF020(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/magaf010';
                })
                .catch((error) => console.log(error));
        }
    };
    const getOptions = (name) => {
        const options = {
            notice: [{ id: 'notice', label: '상단공지설정', value: 'Y' }],
            contentView: [{ id: 'contentView', label: '내용같이보기설정', value: 'Y' }],
        };
        return options[name];
    };

    return (
        <div className="container dental-magazine">
            <div className="wrap">
                <SideMenu menu={MENU_CENTER} />
                <div id="tableVolunteer" style={{ width: '100%' }}>
                    <div className="header-frame">{/* <h3 className="vln__tit vln__tit--pt44">공지/소식</h3> */}</div>
                    <div className="vln-mgzn__detail">
                        <div className="vln-mgzn__top">
                            <div className="vln-mgzn__lf">
                                <span className="vln-mgzn__gb blue">{getGubun(data?.gubun)}</span>
                                <div className="vln-mgzn__tit">
                                    <h3>{data?.title}</h3>
                                </div>
                            </div>
                            <div className="vln-mgzn__view">{formatDate(data?.addDate)}</div>
                        </div>
                        <div
                            className="vln-mgzn__cnt"
                            style={{ borderBottom: 'unset' }}
                            dangerouslySetInnerHTML={{
                                __html: data?.contents ? decodeHTML(data?.contents) : '사용 가능한 콘텐츠가 없습니다.',
                            }}
                        ></div>
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th style={{ width: '200px' }}>
                                        <span>대상</span>
                                    </th>
                                    <td colSpan={3}>
                                        {data?.target === 'A'
                                            ? '전체회원'
                                            : data?.target === 'C'
                                                ? '치과회원'
                                                : data?.target === 'P'
                                                    ? '개인회원'
                                                    : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ width: '200px' }}>
                                        <span>상단공지설정</span>
                                    </th>
                                    <td>
                                        <CheckGroup
                                            name="notice"
                                            options={getOptions('notice')}
                                            checkedValues={data?.notice}
                                            type="checkbox"
                                            disabled={true}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ width: '200px' }}>
                                        <span>내용같이보기</span>
                                    </th>
                                    <td>
                                        <CheckGroup
                                            name="contentView"
                                            options={getOptions('contentView')}
                                            checkedValues={data?.contentView}
                                            type="checkbox"
                                            disabled={true}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        className="bottom-content"
                        style={{ justifyContent: 'start', gap: '15px', marginTop: '0px', border: 'unset' }}
                    >
                        <Link
                            to="/magaf010"
                            className="button-back-to-list"
                            style={{ padding: '0 23px', height: '30px' }}
                        >
                            목록
                        </Link>
                        <div className="button-form">
                            <button
                                className="btn btn-primary button-back-to-list button-delete"
                                onClick={() => {
                                    handleDelete();
                                }}
                            >
                                삭제
                            </button>
                        </div>
                        <div className="button-form">
                            <Link to={`/magaf020-${id}`} className="btn btn-primary button-save">
                                수정
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAF030;
